export default class MenuMock {
    static get(query) {
        if (query.length > 0) {
            // console.log(query)
        }
        return MenuMock.mainmenu()
    }
//  static mainmenu () {
//    return {'data': {
//      'Menu': {
//        'items': [
//          {'id': 0,
//            'titlecode': 'menutitle',
//            'subtitlecode': 'autismmenu1',
//            'url': '#',
//            'items': [{
//              'id': 21,
//              'titlecode': 'autismmenu0',
//              'url': '#/content/basic-information'
//            },{
//              'id': 1,
//              'titlecode': 'autismmenu2',
//              'url': '#/content/what-is'
//            },
//            {
//              'id': 2,
//              'titlecode': 'autismmenu3',
//              'url': '#/content/symptoms'
//            },
//            {
//              'id': 3,
//              'titlecode': 'autismmenu4',
//              'url': '#/content/step-by-step'
//            },
//            {
//              'id': 4,
//              'titlecode': 'autismmenu5',
//              'url': '#/calendar'
//            }
//            ]
//          },
//          {'id': 5,
//            'titlecode': 'autismmenu6',
//            'subtitlecode': '',
//            'url': '#',
//            'items': [{
//              'id': 6,
//              'titlecode': 'autismmenu7',
//              'url': '#'
//            },
//            {
//              'id': 7,
//              'titlecode': 'autismmenu8',
//              'url': '#'
//            },
//            {
//              'id': 8,
//              'titlecode': 'autismmenu9',
//              'url': '#'
//            },
//            {
//              'id': 9,
//              'titlecode': 'autismmenu10',
//              'url': '#'
//            },
//            {
//              'id': 10,
//              'titlecode': 'autismmenu11',
//              'url': '#'
//            },
//            {
//              'id': 11,
//              'titlecode': 'autismmenu12',
//              'url': '#'
//            },
//            {
//              'id': 12,
//              'titlecode': 'autismmenu11',
//              'url': '#'
//            },
//            {
//              'id': 13,
//              'titlecode': 'autismmenu12',
//              'url': '#'
//            },
//            {
//              'id': 14,
//              'titlecode': 'autismmenu13',
//              'url': '#'
//            },
//            {
//              'id': 15,
//              'titlecode': 'autismmenu14',
//              'url': '#'
//            }
//            ]
//          },
//          {'id': 16,
//            'titlecode': 'autismmenu15',
//            'subtitlecode': '',
//            'url': '#',
//            'items': [{
//              'id': 17,
//              'titlecode': 'autismmenu16',
//              'url': '#/form'
//            },
//            {
//              'id': 18,
//              'titlecode': 'autismmenu17',
//              'url': '#/form'
//            }
//            ]
//          },
//           {'id': 19,
//            'titlecode': 'autismmenu18',
//            'subtitlecode': '',
//            'url': '#/maps',
//            'items': [ ]
//          },
//           {'id': 20,
//            'titlecode': 'autismmenu19',
//            'subtitlecode': '',
//            'url': '#/contact',
//            'items': [ ]
//          }
//
//        ]
//      }
//    }
//    }
//  }
    static mainmenu() {
        return {'data': {
                'Menu': {
                    'items': [
                        
                        {'id': 0,
                            'titlecode': 'menutitle',
                            'subtitlecode': 'a1',
                            'url': '#',
                            'items': [{
                                    'id': 22,
                                    'titlecode': 'a1',
                                    'url': '#/content/a1'
                                },{
                                    'id': 21,
                                    'titlecode': 'a2',
                                    'url': '#/content/a2'
                                }, {
                                    'id': 1,
                                    'titlecode': 'a3',
                                    'url': '#/content/a3'
                                },
                                {
                                    'id': 2,
                                    'titlecode': 'a4',
                                    'url': '#/content/a4'
                                },
                                {
                                    'id': 3,
                                    'titlecode': 'a5',
                                    'url': '#/content/a5'
                                },
                                {
                                    'id': 4,
                                    'titlecode': 'a6',
                                    'url': '#/content/a6'
                                }
                            ]
                        },
                           {'id': 23,
                            'titlecode': 'a30',
							'cssClass': 'secondary-color',
                            'subtitlecode': '',
                            'url': '#',
                            'items': [{
                                    'id': 24,
                                    'titlecode': 'a31',
                                    'url': '#/form/dla-rodzin'
                                }, {
                                    'id': 25,
                                    'titlecode': 'a32',
                                    'url': '#/form/pracownicy'
                                } 
                            ]
                        },
                        {'id': 5,
                            'titlecode': 'a7',
                            'subtitlecode': '',
                            'url': '#',
                            'items': [{
                                    'id': 6,
                                    'titlecode': 'a8',
                                    'url': '#/content/a8'
                                }, {
                                    'id': 7,
                                    'titlecode': 'a9',
                                    'url': '#/content/a9'
                                },
                                {
                                    'id': 8,
                                    'titlecode': 'a10',
                                    'url': '#/content/a10'
                                },
                                {
                                    'id': 9,
                                    'titlecode': 'a11',
                                    'url': '#/content/a11'
                                } 
                            ]
                        },
                         {'id': 10,
                            'titlecode': 'a12',
                            'subtitlecode': '',
                            'url': '#',
                            'items': [{
                                    'id': 11,
                                    'titlecode': 'a13',
                                    'url': '#/content/a13'
                                }, {
                                    'id': 12,
                                    'titlecode': 'a14',
                                    'url': '#/content/a14'
                                },
                                {
                                    'id': 13,
                                    'titlecode': 'a15',
                                    'url': '#/content/a15'
                                },
                                {
                                    'id': 14,
                                    'titlecode': 'a16',
                                    'url': '#/content/a16'
                                },
                                {
                                    'id': 15,
                                    'titlecode': 'a17',
                                    'url': '#/content/a17'
                                }, {
                                    'id': 16,
                                    'titlecode': 'a18',
                                    'url': '#/content/a18'
                                }, 
                                {
                                    'id': 18,
                                    'titlecode': 'a20',
                                    'url': '#/content/a20'
                                } 
                            ]
                        },
                        {'id': 19,
                            'titlecode': 'a21',
                            'subtitlecode': '',
                            'url': '#',
                            'items': [{
                                    'id': 20,
                                    'titlecode': 'a22',
                                    'url': '#/content/a22'
                                }, {
                                    'id': 21,
                                    'titlecode': 'a23',
                                    'url': '#/content/a23'
                                } 
                            ]
                        },
                        {'id': 22,
                            'titlecode': 'a24',
                            'subtitlecode': '',
                            'url': '#',
                            'items': [{
                                    'id': 24,
                                    'titlecode': 'a26',
                                    'url': '#/content/a26'
                                },
                                {
                                    'id': 25,
                                    'titlecode': 'a27',
                                    'url': '#/content/a27'
                                },
                                {
                                    'id': 26,
                                    'titlecode': 'a28',
                                    'url': '#/content/a28'
                                },
                                {
                                    'id': 27,
                                    'titlecode': 'a29',
                                    'url': '#/content/a29'
                                } 
                            ]
                        },
                        {'id': 28,
                            'titlecode': 'autismmenu20',							
							'cssClass': 'secondary-color',
                            'subtitlecode': 'autismmenu18',
                            'url': '#/maps',
                            'items': []
                        },
                        {'id': 29,
                            'titlecode': 'autismmenu19',
                            'subtitlecode': '',
                            'url': '#/contact',
                            'items': []
                        }

                    ]
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/static/api/mock/MenuMock.js